import * as React from "react";
import en from "./en";

export const userlang = "en";

let dictionary: { [key: string]: string } = en;

export function t(key: i18nKeys): string {
  return dictionary[key];
}

// to handle &nbsp; and so on
export function html(str: string): React.ReactNode {
  return React.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: str
    }
  });
}

export enum i18nKeys {
  emailPlaceholder = "emailPlaceholder",
  signIn = "signIn",
  password = "password",
  dontKnowPassword = "dontKnowPassword",
  signInGreetingDescription = "signInGreetingDescription",
  signInGreetingHeader = "signInGreetingHeader",
  landingLinkText = "landingLinkText",

  //request password recovery
  emailForRecovery = "emailForRecovery",
  sendRecoveryEmail = "sendRecoveryEmail",
  sendRecoveryEmailAgain = "sendRecoveryEmailAgain",
  requestPasswordRecoveryGreeting = "requestPasswordRecoveryGreeting",
  requestPasswordRecoveryGreeting2 = "requestPasswordRecoveryGreeting2",
  requestPasswordRecoverySent = "requestPasswordRecoverySent",
  requestPasswordRecoverySuccessTitle = "requestPasswordRecoverySuccessTitle",
  requestPasswordRecoverySuccessSubtitle1 = "requestPasswordRecoverySuccessSubtitle1",
  requestPasswordRecoverySuccessSubtitle2 = "requestPasswordRecoverySuccessSubtitle2",
  cancelRecover = "cancelRecover",
  ifNeedHelp = "ifNeedHelp",
  contactUs = "contactUs",

  //confirm password page
  setANewPassword = "setANewPassword",
  setPasswordAndSignIn = "setPasswordAndSignIn",
  nowSetANewPassword = "nowSetANewPassword",
  confirmPassword = "confirmPassword",
  passwordsDoNotMatchTitle = "passwordsDoNotMatchTitle",
  passwordsDoNotMatchSubtitle = "passwordsDoNotMatchSubtitle",

  //Login Service Errors
  invalidCredentialsErrorTitle = "invalidCredentialsErrorTitle",
  invalidCredentialsErrorSubtitle = "invalidCredentialsErrorSubtitle",
  weakPassword = "weakPassword",
  unknownError = "unknownError",
  termsOfUseTitle = "termsOfUseTitle",
  termsOfUseDescription = "termsOfUseDescription",
  acceptAndContinue = "acceptAndContinue",
  decline = "decline",
  emailRequired = "emailRequired",
  incorrectEmail = "incorrectEmail",
  passwordRequired = "passwordRequired",
  unknownErrorSubTitle1 = "unknownErrorSubTitle1",
  unknownErrorSubTitle2 = "unknownErrorSubTitle2",
  unknownErrorSubTitle3 = "unknownErrorSubTitle3",
  changePasswordGreetingTitle = "changePasswordGreetingTitle",
  changePasswordGreetingDiscription = "changePasswordGreetingDiscription",
  tooManyAttemptsTitle = "tooManyAttemptsTitle",
  tooManyAttemptsSubtitle = "tooManyAttemptsSubtitle"
}
